/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-04-19 14:57:06 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-04-23 13:46:07
 */
import * as React from "react";
import Dropzone from "react-dropzone";
import Button from "material-ui/RaisedButton";
import UploadIcon from "material-ui/svg-icons/file/file-upload";
import flatMap from "lodash/flatMap";

import { importVessels } from "services/vessels/import";

const styles = {
    dropzone: {
        width: "100%",
        height: "200px",
        borderWidth: "2px",
        borderColor: "rgb(102, 102, 102)",
        borderStyle: "dashed",
        borderRadius: "5px",

        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",

        cursor: "pointer"
    },
    uploadIconStyle: {
        color: "rgb(154, 154, 154)",
        width: "48px",
        height: "48px"
    },
    resultWrapper: {
        flexDirection: "column"
    },
    resultHeader: {
        textAlign: "center"
    },
    itemsContainer: {
        maxHeight: "400px",
        overflowY: "auto",
    },
    itemHeader: {
        textAlign: "center",
        paddingTop: "0.5em",
        marginTop: "0.5em",
        marginBottom: "0.5em",
        borderTop: "1px #909090 solid",
        display: "block"
    },
    itemStyle: {
        margin: "0"
    },
    forceUpdate: {
        margin: "1em auto 0"
    }
}

export default class VesselImport extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {};

        this.onDrop = this.onDrop.bind(this);
        this.forceUpdateVessels = this.forceUpdateVessels.bind(this);
    }

    async forceUpdateVessels() {
        await this.tryImport(this.lastFile, true);
    }

    async onDrop(acceptedFiles, rejectedFiles, forceUpdate = false) {
        this.lastFile = acceptedFiles[0];

        await this.tryImport(this.lastFile);
    }

    async tryImport(file, forceUpdate = false) {
        this.setState({ loading: true });
        try {
            const response = await importVessels(file, forceUpdate);

            this.setState({
                loading: false,
                forceSaveAvailable: false,
                header: "No changes to save",
                data: undefined
            });
        }
        catch (error) {
            const { status, statusText, errors } = error.response.data;

            this.setState({
                loading: false,
                forceSaveAvailable: status == 409,
                header: statusText,
                data: errors
            });
        }
        finally {
            this.props.onUpdate && this.props.onUpdate();
        }
    }

    render() {
        const dropzoneStyle = {
            ...styles.dropzone,
            cursor: this.state.loading ? "wait" : "pointer"
        };
        return (
            <div className="content">
                <div className="row">
                    <Dropzone multiple={false} style={dropzoneStyle} onDrop={this.onDrop}>
                    {
                        this.state.loading 
                            ? <p>Loading...</p>
                            : <React.Fragment>
                                <UploadIcon style={styles.uploadIconStyle} />
                                <p>Choose a file or drag it here</p>
                            </React.Fragment>
                    }
                    </Dropzone>
                </div>
                <div className="row">
                    { this.state.forceSaveAvailable && this.lastFile
                        ? <Button label="Update" secondary={true} disabled={this.state.loading} style={styles.forceUpdate} onClick={this.forceUpdateVessels} />
                        : null
                    }
                </div>
                <div className="row" style={styles.resultWrapper}>
                    <h3 style={styles.resultHeader}>{ this.state.header }</h3>
                    <div style={styles.itemsContainer}>
                    {
                        this.state.data 
                            ? flatMap(this.state.data, error => {
                                return [
                                    <b style={styles.itemHeader}>{error.ship}</b>,
                                    // backend ensure us content will be safe :)
                                    ...error.messages.map(item => <p style={styles.itemStyle} dangerouslySetInnerHTML={{__html: item}}></p>)
                                ];
                            }) 
                            : ""
                    }
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Vessels/List/VesselImport.jsx